// @givmo/crm — the CRM's own frame for the contact import (`/crm/import` in a host console). The
// wizard itself is `CrmImportWizard`, which other modules rent in place.

import { useNavigate } from '@tanstack/react-router';
import type { CrmModuleConfig } from './crm-config';
import { CrmImportWizard } from './crm-import-wizard';

export function CrmImportPage({
  config,
  initialFile,
}: {
  config: CrmModuleConfig;
  /** Preview seam: open on a file already chosen. */
  initialFile?: { name: string; text: string };
}) {
  const navigate = useNavigate();
  const toContacts = () => void navigate({ to: config.links.contacts });
  return <CrmImportWizard config={config} onDone={toContacts} initialFile={initialFile} />;
}
